import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';

export interface OrganisationInfo {
  id: string;
  name: string;
}

export interface OrganisationResponse {
  currentOrganisation: OrganisationInfo | null;
  availableOrganisations: OrganisationInfo[];
}

export const getCurrentOrganisation =
  async (): Promise<OrganisationResponse> => {
    const response = await authenticatedApi.get<OrganisationResponse>(
      '/api/v1/organisations/current'
    );

    return response.data;
  };
